/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Studio_Tab_EditInputs */

const en_landing_studio_tab_edit = /** @type {(inputs: Landing_Studio_Tab_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edit an image`)
};

const zh_landing_studio_tab_edit = /** @type {(inputs: Landing_Studio_Tab_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`编辑图片`)
};

/**
* | output |
* | --- |
* | "Edit an image" |
*
* @param {Landing_Studio_Tab_EditInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_studio_tab_edit = /** @type {((inputs?: Landing_Studio_Tab_EditInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Studio_Tab_EditInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_studio_tab_edit(inputs)
	return zh_landing_studio_tab_edit(inputs)
});
export { landing_studio_tab_edit as "landing.studio.tab_edit" }